<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.68 7.26 8.18 10.81M14.68 16.74 8.18 13.19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<circle cx="17" cy="6" r="2.25" stroke="currentColor" stroke-width="1.6"/>
<circle cx="6" cy="12" r="2.25" stroke="currentColor" stroke-width="1.6"/>
<circle cx="17" cy="18" r="2.25" stroke="currentColor" stroke-width="1.6"/>
</svg>
</template>
